import React from 'react';
import { PageHero } from '../components/Sections';
import ContactForm from '../components/ContactForm';
import { siteSettings as fb } from '../data/mock';
import { useContent } from '../context/ContentContext';
import Seo from '../components/Seo';
import { businessLd } from '../lib/seo';
import { Phone, Mail, MapPin, Printer, Clock } from 'lucide-react';

const Contact = () => {
  const { siteSettings = fb, serviceAreas = [] } = useContent();
  return (
    <div>
    <Seo
      title="Contact Comfort Air Mechanical | HVAC in Cortez, CO | (970) 565-7893"
      description="Contact Comfort Air Mechanical in Cortez, CO for heating & air conditioning service, repair and free estimates. Call (970) 565-7893 or request service online. 24/7 emergency service."
      path="/contact"
      jsonLd={businessLd(siteSettings, { areaServed: serviceAreas })}
    />
    <PageHero title="Get In Touch" subtitle="Questions, estimates or emergencies — we're here to help 24/7." crumb="Contact" />
    <section className="section-pad bg-white">
      <div className="container-c grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <h2 className="font-display font-extrabold text-3xl text-brand-bluedark">Contact Information</h2>
          <div className="h-1 w-20 bg-brand-green rounded-full mt-4 mb-8" />
          <div className="space-y-5">
            {[
              { icon: MapPin, label: 'Address', value: `${siteSettings.address}, ${siteSettings.city}` },
              { icon: Phone, label: 'Phone', value: siteSettings.phone, href: `tel:${siteSettings.phoneRaw}` },
              { icon: Printer, label: 'Fax', value: siteSettings.fax },
              { icon: Mail, label: 'Email', value: siteSettings.email, href: `mailto:${siteSettings.email}` }
            ].map((c) => (
              <div key={c.label} className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-brand-bluelight flex items-center justify-center shrink-0">
                  <c.icon className="text-brand-blue" size={22} />
                </div>
                <div>
                  <div className="text-sm text-slate-500 font-medium">{c.label}</div>
                  {c.href ? <a href={c.href} className="font-display font-semibold text-brand-bluedark hover:text-brand-green">{c.value}</a> : <div className="font-display font-semibold text-brand-bluedark">{c.value}</div>}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 bg-brand-bluelight rounded-2xl p-6">
            <h3 className="font-display font-bold text-brand-bluedark flex items-center gap-2 mb-3"><Clock size={20} className="text-brand-green" /> Business Hours</h3>
            <ul className="space-y-2 text-sm">
              {siteSettings.hours.map((h) => (
                <li key={h.day} className="flex justify-between"><span className="text-slate-600">{h.day}</span><span className="font-semibold text-brand-bluedark">{h.time}</span></li>
              ))}
            </ul>
            <div className="mt-3 text-brand-green font-semibold text-sm">{siteSettings.emergencyNote}</div>
          </div>

          <div className="mt-6 rounded-2xl overflow-hidden shadow-sm border border-slate-100">
            <iframe title="map" src="https://www.google.com/maps?q=Cortez,CO&output=embed" className="w-full h-56 border-0" loading="lazy" />
          </div>
        </div>

        <div>
          <h2 className="font-display font-extrabold text-3xl text-brand-bluedark">Send Us a Message</h2>
          <div className="h-1 w-20 bg-brand-green rounded-full mt-4 mb-8" />
          <ContactForm />
        </div>
      </div>
    </section>
  </div>
  );
};

export default Contact;
